import { useContext } from "react";
import ConnectionsStatusContext from "../ConnectionsStatusContext";
/**
 * @description Returns the connection status context
 */
export const useConnectionStatusContext = () => {
  return useContext(ConnectionsStatusContext);
};
